import { useEffect } from "react";
import { convertNumberToWords, currency } from "../../utils/number.utils";

export default function InwordsTotalField({ watch, control, errors, setValue, others }) {
  const multiCars = watch("multiCars");
  const isMulti = watch("isMultiQuot");

  function handleTotal(name) {
    const price = watch(`car.${name}`);
    return price ? Number(price) : 0;
  }

  function handleMultiTotal(name) {
    return multiCars.reduce((prev, car, index) => {
      const price = watch(`car.${index}.${name}`);
      return price ? prev + Number(price) : prev;
    }, 0);
  }

  let total = 0;
  let inwords = convertNumberToWords(total);

  if (isMulti) {
    const totalPrice = handleMultiTotal("price");
    const totalReg = handleMultiTotal("registration_cost");
    total = totalPrice + totalReg;
    inwords = convertNumberToWords(total);
  } else {
    total = handleTotal("price") + handleTotal("registration_cost");
    inwords = convertNumberToWords(total);
  }

  useEffect(() => {
    if (isMulti) {
      // Set the total and inwords in the form state
      setValue("amount.total", total);
      setValue("amount.inwords", inwords);
    } else {
      // Set the total and inwords in the form state
      setValue("car.total", total);
      setValue("car.inwords", inwords);
    }
  }, [setValue, isMulti, total, inwords]);

  return (
    <div className="card mb-3">
      <div className="card-body">
        <p className="mb-0">
          <span style={{ fontWeight: 600 }}>Total:</span> {currency(total)}
        </p>
        <p className="mb-0">
          <span style={{ fontWeight: 600 }}>Inwords:</span> {inwords}
        </p>
      </div>
    </div>
  );
}
